// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__N4asI"};